import { getCurrencySymbolFromCode } from '@moonpig/web-core-utils'
import { Locale } from '@moonpig/web-core-locale-text'
import { Price, Variant } from '../../types'
import { E_CARD_SIZE_ID } from '../../constants'

type FormatProductVariantsArgs = {
  variants: Variant[]
  selectedVariant: Variant
  id: string
  language: Locale
  eCardDescription?: string
}

const formatPrice = ({
  language,
  fractionDigits,
  price,
}: {
  language: Locale
  fractionDigits: number
  price: number
}) => {
  return Intl.NumberFormat(language, {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  }).format(Math.abs(price))
}

const mapPrice = (price: Price, language: Locale, minimumQuantity: number) => {
  const decimalPrice = (price.centAmount * minimumQuantity) / 100
  const currencySymbol = getCurrencySymbolFromCode(price.currencyCode)

  const displayPrice = decimalPrice

  const localePrice = formatPrice({
    language,
    fractionDigits: price.fractionDigits,
    price: displayPrice,
  })

  const itemPrice = formatPrice({
    language,
    fractionDigits: price.fractionDigits,
    price: decimalPrice,
  })

  return {
    displayPrice: localePrice,
    itemPrice,
    description: '',
    currencyCode: price.currencyCode,
    currencySymbol,
    centAmount: price.centAmount * minimumQuantity,
    fractionDigits: price.fractionDigits,
  }
}

export const formatProductVariants = ({
  variants,
  selectedVariant,
  id,
  language,
  eCardDescription,
}: FormatProductVariantsArgs) => {
  return variants.map(variant => {
    const subtitle =
      (variant.subtitle || variant?.dimensions?.description) ?? ''

    const description =
      variant.key === E_CARD_SIZE_ID ? eCardDescription : subtitle

    const {
      title,
      price,
      fullPrice,
      discountedPercentage,
      key,
      inStock,
      sku,
      addons,
      minimumQuantity,
      quantityOption,
    } = variant

    const quantityMinimum =
      minimumQuantity ??
      (quantityOption?.__typename === 'RangeQuantity'
        ? quantityOption.minimum
        : undefined) ??
      1
    const mappedPrice = mapPrice(price, language, quantityMinimum)

    const mappedFullPrice = mapPrice(fullPrice, language, quantityMinimum)

    return {
      ...variant,
      label: title,
      price: mappedPrice,
      fullPrice: mappedFullPrice,
      discountedPercentage,
      value: key,
      description,
      selected: key === selectedVariant.key,
      inStock,
      sku: sku || `${id}-${key}`,
      addons,
    }
  })
}
